export interface TrafficSource {
  id: number;
  source: string;
  medium: string;
  sessions: number;
  conversions: number;
  conversionRate: number;
  avgSessionDuration: string;
  eventsPerSession: number;
  bounceRate: number;
  icon: string;
  color: string;
}

export interface UtmRow {
  id: number;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmContent: string;
  utmTerm: string;
  sessions: number;
  conversions: number;
  conversionRate: number;
  avgDuration: string;
  eventsPerSession: number;
}

export const trafficSources: TrafficSource[] = [
  { id: 1, source: 'Google Ads', medium: 'cpc', sessions: 3240, conversions: 272, conversionRate: 8.4, avgSessionDuration: '4m 22s', eventsPerSession: 7.2, bounceRate: 28.4, icon: 'ri-google-line', color: '#D4AF37' },
  { id: 2, source: 'Instagram', medium: 'social', sessions: 2810, conversions: 174, conversionRate: 6.2, avgSessionDuration: '3m 45s', eventsPerSession: 6.1, bounceRate: 32.1, icon: 'ri-instagram-line', color: '#E4405F' },
  { id: 3, source: 'Facebook', medium: 'paid', sessions: 1920, conversions: 98, conversionRate: 5.1, avgSessionDuration: '3m 10s', eventsPerSession: 5.4, bounceRate: 38.5, icon: 'ri-facebook-circle-line', color: '#1877F2' },
  { id: 4, source: 'Organik', medium: 'organic', sessions: 1430, conversions: 62, conversionRate: 4.3, avgSessionDuration: '5m 02s', eventsPerSession: 8.9, bounceRate: 24.7, icon: 'ri-search-line', color: '#7CB342' },
  { id: 5, source: 'TikTok', medium: 'social', sessions: 890, conversions: 34, conversionRate: 3.8, avgSessionDuration: '2m 55s', eventsPerSession: 4.8, bounceRate: 44.2, icon: 'ri-tiktok-line', color: '#010101' },
  { id: 6, source: 'YouTube', medium: 'video', sessions: 640, conversions: 31, conversionRate: 4.8, avgSessionDuration: '5m 40s', eventsPerSession: 9.2, bounceRate: 21.8, icon: 'ri-youtube-line', color: '#FF0000' },
  { id: 7, source: 'Direkt', medium: 'direct', sessions: 520, conversions: 28, conversionRate: 5.4, avgSessionDuration: '4m 50s', eventsPerSession: 7.8, bounceRate: 26.3, icon: 'ri-global-line', color: '#64B5F6' },
  { id: 8, source: 'E-Posta', medium: 'email', sessions: 310, conversions: 22, conversionRate: 7.1, avgSessionDuration: '4m 15s', eventsPerSession: 6.9, bounceRate: 29.0, icon: 'ri-mail-line', color: '#AB47BC' },
];

export const utmRows: UtmRow[] = [
  { id: 1, utmSource: 'google', utmMedium: 'cpc', utmCampaign: 'spring-botoks', utmContent: 'ad-variant-a', utmTerm: 'botoks istanbul', sessions: 1240, conversions: 112, conversionRate: 9.0, avgDuration: '4m 45s', eventsPerSession: 7.8 },
  { id: 2, utmSource: 'instagram', utmMedium: 'social', utmCampaign: 'lazer-mar', utmContent: 'story-v2', utmTerm: '', sessions: 980, conversions: 68, conversionRate: 6.9, avgDuration: '3m 52s', eventsPerSession: 6.4 },
  { id: 3, utmSource: 'facebook', utmMedium: 'paid', utmCampaign: 'lazer-fb-q1', utmContent: 'carousel', utmTerm: 'lazer epilasyon', sessions: 720, conversions: 42, conversionRate: 5.8, avgDuration: '3m 20s', eventsPerSession: 5.2 },
  { id: 4, utmSource: 'google', utmMedium: 'cpc', utmCampaign: 'dermapen-q1', utmContent: 'responsive', utmTerm: 'dermapen cilt', sessions: 680, conversions: 54, conversionRate: 7.9, avgDuration: '4m 10s', eventsPerSession: 7.1 },
  { id: 5, utmSource: 'tiktok', utmMedium: 'social', utmCampaign: 'spa-tiktok', utmContent: 'video-15s', utmTerm: '', sessions: 460, conversions: 18, conversionRate: 3.9, avgDuration: '2m 40s', eventsPerSession: 4.3 },
  { id: 6, utmSource: 'instagram', utmMedium: 'social', utmCampaign: 'hydra-spring', utmContent: 'reel-v1', utmTerm: '', sessions: 820, conversions: 78, conversionRate: 9.5, avgDuration: '4m 58s', eventsPerSession: 8.2 },
  { id: 7, utmSource: 'email', utmMedium: 'newsletter', utmCampaign: 'march-deals', utmContent: 'cta-button', utmTerm: '', sessions: 310, conversions: 22, conversionRate: 7.1, avgDuration: '4m 15s', eventsPerSession: 6.9 },
  { id: 8, utmSource: 'youtube', utmMedium: 'video', utmCampaign: 'yt-before-after', utmContent: 'preroll', utmTerm: 'güzellik merkezi', sessions: 640, conversions: 31, conversionRate: 4.8, avgDuration: '5m 40s', eventsPerSession: 9.2 },
];

export const sourceConversionChart = [
  { source: 'Google Ads', convRate: 8.4, sessions: 3240 },
  { source: 'E-Posta', convRate: 7.1, sessions: 310 },
  { source: 'Direkt', convRate: 5.4, sessions: 520 },
  { source: 'Instagram', convRate: 6.2, sessions: 2810 },
  { source: 'Facebook', convRate: 5.1, sessions: 1920 },
  { source: 'YouTube', convRate: 4.8, sessions: 640 },
  { source: 'Organik', convRate: 4.3, sessions: 1430 },
  { source: 'TikTok', convRate: 3.8, sessions: 890 },
];

export const sourceDropOffChart = [
  { source: 'YouTube', dropOff: 21.8 },
  { source: 'Organik', dropOff: 24.7 },
  { source: 'Direkt', dropOff: 26.3 },
  { source: 'Google Ads', dropOff: 28.4 },
  { source: 'E-Posta', dropOff: 29.0 },
  { source: 'Instagram', dropOff: 32.1 },
  { source: 'Facebook', dropOff: 38.5 },
  { source: 'TikTok', dropOff: 44.2 },
];

export const weeklyTrafficData = [
  { day: 'Pzt', google: 420, instagram: 310, facebook: 220, organic: 180 },
  { day: 'Sal', google: 380, instagram: 340, facebook: 240, organic: 200 },
  { day: 'Çar', google: 460, instagram: 290, facebook: 200, organic: 190 },
  { day: 'Per', google: 510, instagram: 380, facebook: 270, organic: 220 },
  { day: 'Cum', google: 580, instagram: 420, facebook: 310, organic: 250 },
  { day: 'Cmt', google: 490, instagram: 460, facebook: 280, organic: 210 },
  { day: 'Paz', google: 400, instagram: 410, facebook: 240, organic: 180 },
];
